import styled from "styled-components";

export const StyleCompany = styled.div`
.companyWrap {
    background: #fff;
    width: 100%;
    height: 100vw;
    padding: 30px 0;
}

.companyWrap .filtersWrapperTrains {
    margin: 0 30px;
}

.companyWrap .flexDirection {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    margin-right: -60px;
    padding: 0px 30px;
    padding-top: 0px;
    width: 100%;
}

.companyWrap h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 38px;
    margin-top: 0;
    color: #000000;
    margin-bottom: 10px;
    display: block;
    padding: 0px 30px;
}

.companyWrap .descriptionText {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 29px;
    margin-bottom: 26px;
    color: #707070;
    padding: 0px 30px;
}

.companyWrap .img_wrap {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    background: #F8F8F8;
    border-radius: 50%;
}

.companyWrap .companyItem {
    box-shadow: 0px 2px 30px rgb(230 230 230 / 50%);
    border-radius: 5px;
    min-height: 320px;
    padding: 30px;
    background: #fff;
    margin-bottom: 60px;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: calc(25% - 45px);
    margin-right: 60px;
    position: relative;
}

.companyWrap .companyItem .menuIconWrap {
    position: absolute;
    cursor: pointer;
    width: 30px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 15px;
    right: 7px;
}

.companyWrap .companyItem:nth-child(4n) {
    margin-right: 0;
}

.companyWrap .companyItem:hover {
    box-shadow: 0px 5px 10px rgba(192, 192, 192, 0.5);
}

.companyWrap .companyItem.createNew {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
}

.companyWrap .companyItem.createNew.market {
    background-color: rgba(6, 52, 183, 0.1)
}

.blackdrop {
    width: 100px;
    position: absolute;
    height: 100px;
    background-color: #000;
    border-radius: 100px;
    opacity: 0.6;
    z-index: 1;
}

.companyWrap .create_tit {
    margin-bottom: 20px;
    text-align: center;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 28px;
    color: #000000;
    margin-bottom: 0px;
}

.companyWrap .create_des {
    text-align: center;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    text-align: center;
    color: #000000;
}
.dashboard-wrapper .item-wrap-category,
.item-wrap-status,
.item-wrap-client {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #eee;
    padding-bottom: 25px;
    cursor: pointer;
}

.item-wrap-category,
.item-wrap-client {
    cursor: pointer;
}

.companyWrap .drobMenu {
    right: 0;
}

.companyWrap .logo_wrap {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    margin-bottom: 30px;
    box-sizing: border-box;
    border-radius: 50%;
    overflow: hidden;
}

.companyWrap .logo_wrap span {
    width: 100%;
    height: 100%;
}

.companyWrap .logo_wrap img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.companyWrap .itemTit {
    margin-bottom: 14px;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 34px;
    color: #000000;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 0;
}

.companyWrap .itemDesc {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    color: #000000;
    max-height: 90px;
    overflow: hidden;
}

.companyWrap .infoWrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}


.companyWrap .textItem {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    color: #000000;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.companyWrap .textItem:last-child {
    margin-bottom: 0;
}

.companyWrap .textItem span {
    margin: 0 5px;
}

.companyWrap .countMembers .dots {
    background: none;
    border: none;
    padding: 0;

}



.labelClass {
    margin-bottom: 0;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 22px;
    color: #000000;
    display: block;
}

.labelClass.mb15 {
    margin-bottom: 15px;
}

.tabs_wrap {
    display: flex;
    align-items: center;
    padding: 0px 0px;
    margin-bottom: 20px;
    width: 160px;
    justify-content: space-between;
    background: #FFFFFF;
    box-sizing: border-box;
    border-radius: 2px;
    border: solid 1px #eee
}

.tabs_wrap .tab_item {
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    width: 76px;
    height: 36px;
    font-weight: normal;
    font-size: 15px;
    cursor: pointer;
    line-height: 22px;
    color: #000000;
}

.tabs_wrap .tab_item.act {
    background: #EEF4FC;
    border-radius: 2px;
    font-weight: bold;
    font-size: 15px;
    line-height: 22px;
    color: #086AD8;
}

.colors_wrap {
    display: flex;
    flex-wrap: wrap;
}

.colors_wrap span {
    width: 40px;
    height: 40px;
    margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 50%;
    color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.inputContainer {
    max-width: 400px;
}

.inputContainerMb0 {
    max-width: 400px;
}

.avatar.errorBorder {
    border: 2px solid #FE8F80;
}

.mb5 {
    margin-bottom: 5px;
}

.accessesWrap {
    display: flex;
    align-items: center;
    margin-left: 40px;
}

.accessesWrap .accessesItem {
    margin-right: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.accessesWrap .accessesItem.mr30 {
    margin-right: 30px;
}

.accessesWrap .checkbox-wrapper {
    position: relative;
}

.accessesWrap .tit {
    margin-bottom: 10px;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    color: #000000;
}

.Updatebutton {
    background: #086AD8 !important;
    border-radius: 2px;
    color: #EEF4FC !important;
    box-sizing: border-box;
    width: auto;
    padding: 10px 25px;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    margin-bottom: 30px;
    border: 0;
}

.companiesers {
    border-bottom: 2px solid #EEEEEE;
    padding-bottom: 20px;
}

.companiesers .companieser {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.companiesers .companieser:last-child {
    padding-bottom: 0;
}

.deleteUser {
    border: 2px solid #086AD8;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #086AD8;
    border-radius: 2px;
    cursor: pointer;
    display: inline-flex;
}

.memberBtn {
    background: #EEF4FC !important;
    border-radius: 2px;
    color: #086AD8 !important;
    box-sizing: border-box;
    width: auto;
    padding: 6px 24px;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    margin-bottom: 30px;
}

.memberBtn:hover {
    background: #086AD8 !important;
    color: #fff !important;
}

.companyCreateWrap .fileUploaderCreateTrain {
    margin-bottom: 30px;
}

.companyCreateWrap.mrl {
    margin: 0px 30px 0;
}


.optionWrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 15px;
}

.optionWrapper:hover {
    cursor: pointer;
    background-color: #eee;
}

.w255 {
    width: 255px;
}

@media (max-width: 1850px) {
    .companyWrap .companyItem {
        padding: 15px;
        margin-bottom: 30px;
        width: calc(25% - 30px);
        margin-right: 30px;
    }

    .companyWrap .companyItem:nth-child(3n) {
        margin-right: 30px;
    }

    .companyWrap .companyItem:nth-child(4n) {
        margin-right: 0px;
    }
}

@media (max-width: 1280px) {
    .companyWrap .companyItem {
        padding: 20px;
        margin-bottom: 30px;
        width: calc(50% - 15px);
        margin-right: 30px;
        box-shadow: 0px 3px 10px rgb(230 230 230 / 50%)
    }

    .companyWrap .companyItem:nth-child(3n) {
        margin-right: 30px;
    }

    .companyWrap .companyItem:nth-child(2n) {
        margin-right: 0;
    }
}

@media (max-width: 768px) {
    .companyWrap .companyItem {
        padding: 20px;
        margin: 0 auto;
        margin-bottom: 30px;
        width: 100%;
        margin-right: auto;
        max-width: 500px;
    }

    .companyWrap .companyItem:nth-child(3n) {
        margin-right: auto;
    }

    .companyWrap .companyItem:nth-child(2n) {
        margin-right: auto;
    }
}

.txt-task {
    position: absolute;
    bottom: 33px;
}

.item.disable {
    color: #707070;
}

.wrapErrors {
    padding: 15px;
    margin: 30px 0;
    color: #FFFFFF;
    background: #FE8F80;
    display: flex;
    align-items: flex-start;
}

.wrapErrors img {
    width: 25px;
    margin-right: 15px;
    margin-top: 5px;
}

.wrapErrors .errorString {
    font-weight: 700;
    font-size: 16px;
    line-height: 29px;
    margin-bottom: 10px;
}

.wrapErrors .errorString:last-child {
    margin-bottom: 0;
}

.company-table-row td {
    position: relative;
    padding: 10px 15px;
}

.disabledCompany {
    pointer-events: none;
}

.company-welcome-banner {
    display: flex;
    justify-content: center;
    text-align: center;
    font-weight: bold;
}

.company-welcome-banner .alert-danger {
    border-left: none;
}

.p0 {
    padding: 0px !important;
}

.company-dashboard .company-dashboard-input {
    margin-right: 15px;
}

.company-dashboard .company-input-group {
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    align-items: center;
}

.company-dashboard .company-input-group svg {
    stroke-width: 2px;
    color: #aaa;
    cursor: grab;
}

.company-dashboard .company-input-group svg:hover {
    stroke-width: 2px;
    color: #555;
}

.company-dashboard-close {
    width: 18px;
    height: 18px;
    border: 2px solid #086ad8;
    position: relative;
}


.company-dashboard-close:hover {
    cursor: pointer;
}

.company-dashboard-close .leftLine {
    border-bottom: 2px solid #086ad8;
    transform: rotate(45deg);
    width: 70%;
    position: absolute;
    left: 15%;
    top: 40%;
}

.company-dashboard-close .rightLine {
    border-bottom: 2px solid #086ad8;
    transform: rotate(135deg);
    width: 70%;
    position: absolute;
    left: 15%;
    top: 40%;
}

.company-dashboard.border {
    position: relative;
}

.company-dashboard.border:after {
    content: '';
    height: 100vh;
    width: 2px;
    position: absolute;
    right: 0;
    top: 0;
    background-color: #EEEEEE;
}

.company-dashboard .company-dashboard-label {
    font-weight: bold;
    font-weight: 100;
    margin: 0;
    font-size: 18px;
    border-bottom: solid 1px #eee;
    padding-bottom: 15px;
    margin-bottom: 15px;
    margin-top: 12px;
}

.company-dashboard .addButton {
    background: #EEF4FC;
    border-radius: 2px;
    color: #086AD8;
    font-weight: 800;
    margin: 30px 0 0 0;
    padding: 5px 10px;
    display: inline-block;
    cursor: pointer;
    width: max-content;
}

.countdown-box {
    min-height: 30px !important;
    display: flex;
    align-items: center;
}

.company-dashboard-section .hr {
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0;
    border-top: 2px solid #eeeeee;
}


.company-dashboard-section .statuscheckbox{
    position: relative;
    top: -5px;
    margin-right: 40px;
}
.company-dashboard-section .categorycheckbox{
    position: relative;
    top: -5px;
    margin-right: 40px;
}

.company-dashboard-section .checkbox {
    position: relative !important;
}

.company-dashboard-section .categorycheckbox-edit .checkbox-wrapper{
    position: relative;
}
.company-dashboard-section .statuscheckbox-edit .checkbox-wrapper{
    position: relative;
}
.company-dashboard-section{
    margin-left:30px;
}

.edit-company-td {
    position: relative;
    text-align: right;
}

.edit-company-td .checkbox-wrapper {
    top: 0px;
}
.mail{
    display:flex;
    align-items:center;
}
.mail .checkbox{
    margin-left:15px;
}
.Edit-company-mail .mail .checkbox{
    margin-left:15px;
}
.mail .checkbox-wrapper{
    position:relative;
}
.dashboard-category-label {
    display: flex;
    align-items: center;
    padding: 0 10px
    border-radius: 2px;
    border-left: solid 4px #fff;
    height: 50px;
    line-height: 50px;
}

.dashboard-category-label:hover {
    background-color: #eee;
    border-left: solid 4px #eee;
}

.dashboard-category-label svg {
    width: 20px;
    margin-right: 6px;
}
.activeLabel{
    background-color: #eee;
    border-radius: 2px;
    border-left: solid 4px #0061FE!important;
}

.scrollbar{
    overflow-y: auto;
    height: calc(100vh - 185px);
    overflow-x: hidden;
}

.company-table th {
    padding: 10px 15px
}

.item-wrap-category>div{
    flex-basis: 100%;
    display: flex;
    align-items: center;
    align-items: center;
}
.company-dashboard-input-icon{
    cursor: pointer
}

.company-dashboard-section .over{
    background-color: rgba(238, 238, 238, 0.3);
}
.formconfiguration-textarea textarea.sc-ckVGcZ.fRrGdm.form-control {
    padding: 7px 15px;
    margin-top: 14px;
}
.breadcrumb, .company-tab {
    padding: 0 30px
}
.button-style{
    margin-left:10px;
    border:none
}
.border-none{
    border:none
    padding:4px 8px
    border-radius:3px
}
.center-item{
    display:flex;
    align-items:center
}
.add-button {
    background-color: #086AD8;
    color: #fff;
    padding: 5px 10px;
    font-weight: bold;
    border-radius: 2px;
    font-size: 13px;
    border: none;
}
.subHeading {
    display: flex;
    justify-content: space-between;
}
.subHeading-button-container {
    padding-right: 30px
}

.search-filter {
    height: 40px;
    border: 2px solid #dfe3e9;
    border-radius: 2px;
    background-color: #ffffff;
    padding: 0 20px;
    box-shadow: none;
    margin-left: 30px
  }

  .total-data {
    margin-left: auto;
  }

  .date-picker-wrap {
    position: relative;
  }

  .date-picker {
    border-radius: 3px;
    margin-right: 20px;
    border: 1px solid #dddddd;
    background: transparent;
    padding: 10px;
    height: 40px;
    width: 200px;
  }

  .reset-icon {
    position: absolute;
    cursor: pointer
    right: 60px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    background: #fff;
    padding: 3px;
  }
  }
.
`;


// WEBPACK FOOTER //
// ./src/pages/companies/Company_styled.ts